import { type SexSchema, sexSchema } from '@coas/validators/const';
import { atom } from 'jotai';

export const sidebarStateAtom = atom<{ open: boolean; sex: SexSchema }>({
    open: false,
    sex: sexSchema.enum.man,
});
